<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col pt-1">
        <button
          @click="$router.go(-1)" 
          class="btn btn-outline-primary" role="button"
        >
          <span class="fas fa-arrow-circle-left"></span>
        </button>
      </div>
    </div>
    <user-menu-provider v-if="$route.params.mode=='add'" v-on:executeStop="onStopAction"/>
    <transition name="no-mode-translate-fade">
      <user-menu-edit v-if="$route.params.mode=='edit'" v-on:executeStop="onStopAction"/>
    </transition>
    <transition name="no-mode-translate-fade">
      <user-menu-delete v-if="$route.params.mode=='delete'" v-on:executeStop="onStopAction"/>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import UserMenuProvider from "@/components/User/User.Menu.Provider.vue";
import UserMenuDelete from "@/components/User/User.Menu.Delete.vue";
import UserMenuEdit from "@/components/User/User.Menu.Edit.vue";

export default {
  name: "provider",
  components: {
    UserMenuProvider,
    UserMenuDelete,
    UserMenuEdit
  },
  methods: {
    onStopAction: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.no-mode-translate-fade-enter-active,
.no-mode-translate-fade-leave-active {
  transition: all 0.1s;
}
.no-mode-translate-fade-enter,
.no-mode-translate-fade-leave-active {
  opacity: 0;
}
.no-mode-translate-fade-enter {
  transform: translateX(31px);
}
.no-mode-translate-fade-leave-active {
  transform: translateX(-31px);
}
</style>